
import moment from 'moment';

import { Component } from 'vue-property-decorator';
import UrlMixin from '@/components/query/url-mixin';
import ReportMetricsMixin from '@/views/reports/mixins/report-metrics-mixin';
import { mixins } from 'vue-class-component';
import {
  METRICS_CUSTOM_COLUMN,
  METRICS_CUSTOM_EVENT,
  METRICS_CUSTOM_EVENT_HIDDEN_REVENUE,
  METRICS_CUSTOM_EVENT_REVENUE
} from '@/services/constants/report';

@Component({})
export default class Chart extends mixins(UrlMixin,ReportMetricsMixin) {
  chartOptions = null;

  chartSeriesData = {
    // yAxis = 0 - value
    // yAxis = 1 - currency
    // yAxis = 2 - percent
    'reports-impressions':{
      yAxis: 0,
      color: '#e6194b'
      //https://api.highcharts.com/class-reference/Highcharts#.DashStyleValue
      //https://api.highcharts.com/highcharts/series.spline.dashStyle
    },
    'reports-visits':{
      yAxis: 0,
      color: '#3cb44b'
    },
    'reports-clicks':{
      yAxis: 0,
      color: '#ffe119'
    },
    'reports-conversions':{
      yAxis: 0,
      color: '#0082c8'
    },
    'reports-conversionconfirm':{
      yAxis: 0,
      color: '#f58231'
    },
    'reports-revenue':{
      yAxis: 1,
      color: '#911eb4'
    },
    'reports-conversionchargerevenue':{
      yAxis: 1,
      color: '#17becf'
    },
    'reports-cost':{
      yAxis: 1,
      color: '#46f0f0'
    },
    'reports-costbot':{
      yAxis: 1,
      color: '#20b2aa'
    },
    'reports-profit':{
      yAxis: 1,
      color: '#f032e6'
    },
    'reports-hiddenrevenue':{
      yAxis: 1,
      color: '#d2f53c'
    },
    'reports-conversionconfirmhiddenrevenue':{
      yAxis: 1,
      color: '#fabebe'
    },
    'reports-hiddenprofit':{
      yAxis: 1,
      format: '0,0.00',
      color: '#008080'
    },
    'reports-impressionsuniq':{
      yAxis: 0,
      color: '#e6beff'
    },
    'reports-impressionsbot':{
      yAxis: 0,
      color: '#aa6e28'
    },
    'reports-impressionswebview':{
      yAxis: 0,
      color: '#800000'
    },
    'reports-impressionssuspicious':{
      yAxis: 0,
      color: '#aaffc3'
    },
    'reports-impressionssuspiciousblacklistedips':{
      yAxis: 0,
      color: '#808000'
    },
    'reports-impressionssuspiciousdatacenterips':{
      yAxis: 0,
      color: '#ffd8b1'
    },
    'reports-impressions_suspicious_ip_with_frequent_events':{
      yAxis: 0,
      color: '#000080'
    },
    'reports-impressions_suspicious_ip_with_frequent_campaign_events':{
      yAxis: 0,
      color: '#808080'
    },
    'reports-visitsuniq':{
      yAxis: 0,
      color: '#ff7f0e'
    },
    'reports-visitsbot':{
      yAxis: 0,
      color: '#1f77b4'
    },
    'reports-visitswebview':{
      yAxis: 0,
      color: '#2ca02c'
    },
    'reports-visitssuspicious':{
      yAxis: 0,
      color: '#d62728'
    },
    'reports-visitssuspiciousblacklistedips':{
      yAxis: 0,
      color: '#9467bd'
    },
    'reports-visitssuspiciousdatacenterips':{
      yAxis: 0,
      color: '#e377c2'
    },
    'reports-visits_suspicious_ip_with_frequent_events':{
      yAxis: 0,
      color: '#7f7f7f'
    },
    'reports-visits_suspicious_ip_with_frequent_campaign_events':{
      yAxis: 0,
      color: '#bcbd22'
    },
    'reports-clicksuniq':{
      yAxis: 0,
      color: '#17becf'
    },
    'reports-clicksbot':{
      yAxis: 0,
      color: '#393b79'
    },
    'reports-clickswebview':{
      yAxis: 0,
      color: '#637939'
    },
    'reports-conversionswebview':{
      yAxis: 0,
      color: '#ce6dbd'
    },
    'reports-conversionswebviewrevenue':{
      yAxis: 1,
      color: '#8c564b'
    },
    'reports-clickssuspicious':{
      yAxis: 0,
      color: '#8c6d31'
    },
    'reports-clickssuspiciousblacklistedips':{
      yAxis: 0,
      color: '#843c39'
    },
    'reports-clickssuspiciousdatacenterips':{
      yAxis: 0,
      color: '#7b4173'
    },
    'reports-clicks_fast_clicker':{
      yAxis: 0,
      color: '#5254a3'
    },
    'reports-clicks_suspicious_ip_with_frequent_events':{
      yAxis: 0,
      color: '#6b6ecf'
    },
    'reports-clicks_suspicious_ip_with_frequent_campaign_events':{
      yAxis: 0,
      color: '#9c9ede'
    },
    'reports-conversionnew':{
      yAxis: 0,
      color: '#ff9896'
    },
    'reports-conversionconfirmrevenue':{
      yAxis: 1,
      color: '#c5b0d5'
    },
    'reports-conversiondecline':{
      yAxis: 0,
      color: '#c49c94'
    },
    'reports-conversioncharge':{
      yAxis: 0,
      color: '#f7b6d2'
    },
    'reports-conversionsent':{
      yAxis: 0,
      color: '#dbdb8d'
    },
    'reports-cpv':{
      yAxis: 1,
      color: '#9edae5'
    },
    'reports-cpc':{
      yAxis: 1,
      color: '#e41a1c'
    },
    'reports-cpa':{
      yAxis: 1,
      color: '#377eb8'
    },
    'reports-ctr':{
      yAxis: 2,
      color: '#4daf4a'
    },
    'reports-1xctr':{
      yAxis: 0,
      color: '#984ea3'
    },
    'reports-uctr':{
      yAxis: 0,
      color: '#ff7f00'
    },
    'reports-cr':{
      yAxis: 2,
      color: '#1b9e77'
    },
    'reports-1xcr':{
      yAxis: 0,
      color: '#a65628'
    },
    'reports-cv':{
      yAxis: 2,
      color: '#f781bf'
    },
    'reports-1xcv':{
      yAxis: 0,
      color: '#999999'
    },
    'reports-roi':{
      yAxis: 2,
      color: '#66c2a5'
    },
    'reports-epv':{
      yAxis: 1,
      color: '#fc8d62'
    },
    'reports-epc':{
      yAxis: 1,
      color: '#8da0cb'
    },
    'reports-ap':{
      yAxis: 1,
      color: '#b3de69'
    }
  }

  get initialChartOptions(){
    const options = {
      chart: {
        animation: false,
        type: 'spline',
        marginRight:80,
        marginTop:30,
        backgroundColor: 'var(--color-white)',
        style:{
          fontFamily:'Lato, Helvetica, sans-serif, -apple-system'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: <any>null
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      plotOptions: {
      },
      series: [],
      // https://api.highcharts.com/highcharts/yAxis.labels.autoRotation
      xAxis:[],
      yAxis: [
        {
          title: {},
        },
        {
          labels: {
            format: '{value}',
          },
          title: {
            align: 'high',
            offset: 0,
            rotation: 0,
            y: -15,
            x: 15,
            text: this.isDashbord ? this.$store.state.dashboard.query.currency : this.$store.getters.reportParams.currency,
          },
          opposite: true
        },
        {
          labels: {
            format: '{value}%',
          },
          title: {
            // align: 'high',
            // offset: 0,
            // rotation: 0,
            // y: -15,
            // x: 15,
            text: 'Percentage',
          },
          // opposite: true
        }
      ]
    }

    options.xAxis.push( {
      type: 'datetime',
      title:{
        text: this.isDashbord || !this.$store.getters.reportParams.compareEnabled ? '' : 'Main data'
      },
      // max: Number(moment.utc(this.$store.getters.reportParams.to).endOf('month').add(this.addTime.report.amount,this.addTime.report.unit).format('x')),
      dateTimeLabelFormats: {
        millisecond: '%H:%M:%S.%L',
        second: '%H:%M:%S',
        minute: '%H:%M',
        hour: '%H:%M',
        day: '%e. %b',
        week: '%e. %b',
        month: '%b \'%y',
        year: '%Y'
      },
    });

    if(this.$store.getters.reportParams.compareEnabled){
      options.xAxis.push( {
        type: 'datetime',
        opposite: true,
        title:{
          text:'Compare data'
        },
        // max: Number(moment.utc(this.$store.getters.reportParams.compareTo).startOf('month').add(this.addTime.compare.amount,this.addTime.compare.unit).format('x')),
        dateTimeLabelFormats: {
          millisecond: '%H:%M:%S.%L',
          second: '%H:%M:%S',
          minute: '%H:%M',
          hour: '%H:%M',
          day: '%e. %b',
          week: '%e. %b',
          month: '%b \'%y',
          year: '%Y'
        },
      });
    }
    return options;
  }

  get addTime(){
    const toValue = ({to,date})=>{
      switch(date){
        case 'thisMonth':
          return moment().endOf('month').format('YYYY-MM-DD HH:mm:ss');
        case 'today':
        case 'yesterday':
        case 'last24hours':
        case 'last48hours':
        case 'last3days':
        case 'last7days':
        case 'last30days':
        case 'lastMonth':
        case 'customDateTime':
        case 'maxAvailable':
          return to;

      }
    }
    const getPointsAmount = ({from,to,date})=>{
      return moment(toValue({to,date})).diff(from, this.aggregatedValuePlusS)
    }

    const reportDiff = getPointsAmount({
      from:this.$store.getters.tableQueryForCurrentTab.from,
      to:this.$store.getters.tableQueryForCurrentTab.to,
      date:this.$store.getters.tableQueryForCurrentTab.date
    })

    const compareReportDiff = getPointsAmount({
      from:this.$store.getters.tableQueryForCurrentTab.compareFrom,
      to:this.$store.getters.tableQueryForCurrentTab.compareTo,
      date:this.$store.getters.tableQueryForCurrentTab.compareDate
    })


    return {
      report:{
        amount:reportDiff<compareReportDiff ? compareReportDiff - reportDiff : 0,
        unit:this.aggregatedValuePlusS,
      },
      compare:{
        amount:compareReportDiff<reportDiff ? reportDiff - compareReportDiff : 0,
        unit:this.aggregatedValuePlusS,
      }
    }
  }

  get isAllChartHidden(){
    return Object.values(this.$store.state.table[this.isDashbord ? 'chartHiddenSeriesDashboard' : 'chartHiddenSeries']).every(item=>item===true)
  }

  getYAxisSuffix(key){
    const currency = ` ${this.isDashbord ? this.$store.state.dashboard.query.currency : this.$store.getters.tableQueryForCurrentTab.currency}`;

    if (key.startsWith(METRICS_CUSTOM_EVENT)) {
      return ''
    }

    if (key.startsWith(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE)) {
      return currency
    }

    if (key.startsWith(METRICS_CUSTOM_EVENT_REVENUE)) {
      return currency
    }


    if (key.startsWith(METRICS_CUSTOM_COLUMN)) {
      switch (this.$store.getters.getCustomColumns[key.replace(METRICS_CUSTOM_COLUMN,'')]?.format){
        default:
        case 'number':
          return '';
        case 'currency':
          return currency
        case 'percent':
          return '%'
      }
    }

    switch (this.chartSeriesData[key]?.yAxis){
      default:
      case 0:
        return '';
      case 1:
        return currency
      case 2:
        return '%'
    }
  }

  getYAxis(key){
    if (key.startsWith(METRICS_CUSTOM_COLUMN)) {
      switch (this.$store.getters.getCustomColumns[key.replace(METRICS_CUSTOM_COLUMN,'')]?.format){
        default:
        case 'number':
          return 0;
        case 'currency':
          return 1
        case 'percent':
          return 2
      }
    }

    if (key.startsWith(METRICS_CUSTOM_EVENT)) {
      return 0
    }

    if (key.startsWith(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE)) {
      return 1
    }

    if (key.startsWith(METRICS_CUSTOM_EVENT_REVENUE)) {
      return 1
    }

    return this.chartSeriesData[key]?.yAxis;
  }

  getColor(key){
    // this function made by ChatGPT to make color from text, but don't use too light colors
    const textToColorHex = (text)=>  {
      // Simple hash from string
      let hash = 0;
      for (let i = 0; i < text.length; i++) {
        hash = text.charCodeAt(i) + ((hash << 5) - hash);
      }

      // Convert hash to HSL hue (0–360)
      const hue = Math.abs(hash) % 360;

      // Fixed saturation and lightness to avoid washed-out colors
      const saturation = 65; // percent
      const lightness = 45;  // percent – prevents white/near-white

      // Convert HSL to HEX
      return hslToHex(hue, saturation, lightness);
    }

    function hslToHex(h, s, l) {
      s /= 100;
      l /= 100;

      const k = n => (n + h / 30) % 12;
      const a = s * Math.min(l, 1 - l);
      const f = n =>
        Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));

      return `#${f(0).toString(16).padStart(2, '0')}${f(8).toString(16).padStart(2, '0')}${f(4).toString(16).padStart(2, '0')}`;
    }

    if (key.startsWith(METRICS_CUSTOM_EVENT)) {
      return textToColorHex(key)
    }

    if (key.startsWith(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE)) {
      return textToColorHex(key)
    }

    if (key.startsWith(METRICS_CUSTOM_EVENT_REVENUE)) {
      return textToColorHex(key)
    }

    if (key.startsWith(METRICS_CUSTOM_COLUMN)) {
      return textToColorHex(key)
    }

    return this.chartSeriesData[key]?.color;
  }

  handleChartResponse({ data,isCompare }){
    const series = data.series;
    delete data.series;

    if(isCompare){
      this.chartOptions.xAxis[1]= {
        ...this.chartOptions.xAxis[1],
        max: Number(moment.utc(series[series.length - 1]).add(
          this.addTime.compare.amount,
          this.addTime.compare.unit as moment.DurationInputArg2
        ).format('x')) ,
      };
    }else{
      this.chartOptions.xAxis[0]= {
        ...this.chartOptions.xAxis[0],
        max: this.$store.getters.reportParams.compareEnabled
          ?  Number(moment.utc(series[series.length - 1]).add(
            this.addTime.report.amount,
            this.addTime.report.unit as moment.DurationInputArg2
          ).format('x'))
          : null
      };
    }
    Object.keys(data).forEach((key)=>{
      const id = isCompare ? 'compare_'+key : 'id_'+key;

      if(!isCompare){
        this.$store.commit(this.isDashbord ? 'tableChartHiddenSeriesDashboard' : 'tableChartHiddenSeries',{
          id,
          value:!!this.$store.state.table[this.isDashbord ? 'chartHiddenSeriesDashboard' : 'chartHiddenSeries'][id]
        })
      }
      this.chartOptions.series.push( {
        ...this.chartSeriesData[key],
        events: {
          hide:(event)=>{
            if(!event.target.options.isCompare){
              this.$store.commit(this.isDashbord ? 'tableChartHiddenSeriesDashboard' : 'tableChartHiddenSeries',{
                id:event.target.options.id,
                value:true
              })
            }
          },
          show:(event)=>{
            if(!event.target.options.isCompare){
              this.$store.commit(this.isDashbord ? 'tableChartHiddenSeriesDashboard' : 'tableChartHiddenSeries',{
                id:event.target.options.id,
                value:false
              })
            }
          }
        },
        data: data[key],
        name: this.reportMetricsName(key),
        pointStart: Number(moment.utc(series[0]).format('x')),
        xAxis: isCompare ? 1 : 0 ,
        yAxis: this.getYAxis(key),
        color: this.getColor(key),
        pointInterval: this.pointInterval,
        pointIntervalUnit: this.pointIntervalUnit,
        isCompare,
        tooltip:{
          pointFormat:`<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}${this.getYAxisSuffix(key)}</b><br/>`
        },
        id,
        ...(isCompare ? {
          linkedTo:'id_'+key,
          dashStyle:'Dot', //https://jsfiddle.net/gh/get/library/pure/highcharts/highcharts/tree/master/samples/highcharts/plotoptions/series-dashstyle-all/
          name:this.reportMetricsName(key) + ' compare',
        } : {
          visible: !this.$store.state.table[this.isDashbord ? 'chartHiddenSeriesDashboard' : 'chartHiddenSeries'][id],
        }),

      })
    })

  }


  get aggregatedValueRange(){
    if(this.isDashbord){
      return {
        date:this.$store.state.dashboard.query.date,
        from:this.$store.state.dashboard.query.from,
        to:this.$store.state.dashboard.query.to,
      };
    }
    if(this.$store.getters.reportParams.compareEnabled){
      const reportDaysDiff = moment(this.$store.getters.tableQueryForCurrentTab.to).diff(this.$store.getters.tableQueryForCurrentTab.from, 'hours');
      const compareReportDaysDiff = moment(this.$store.getters.tableQueryForCurrentTab.compareTo).diff(this.$store.getters.tableQueryForCurrentTab.compareFrom, 'hours');

      if(compareReportDaysDiff>reportDaysDiff){
        return {
          date:this.$store.getters.tableQueryForCurrentTab.compareDate,
          from:this.$store.getters.tableQueryForCurrentTab.compareFrom,
          to:this.$store.getters.tableQueryForCurrentTab.compareTo,
        };
      }
    }
    return {
      date:this.$store.getters.tableQueryForCurrentTab.date,
      from:this.$store.getters.tableQueryForCurrentTab.from,
      to:this.$store.getters.tableQueryForCurrentTab.to,
    };
  }

  get aggregatedValue(){
    const { to, from, date = 'today' } = this.aggregatedValueRange;
    switch (date) {
      case 'last24hours':
      case 'last48hours':
      case 'today':
        return 'hour';
      case 'yesterday':
        return 'hour';
      case 'last3days':
        return 'day';
      case 'last7days':
        return 'day';
      case 'last30days':
        return 'day';
      case 'thisMonth':
        return 'day';
      case 'lastMonth':
        return 'day';
      case 'maxAvailable':
      case 'customDateTime':
        const daysDiff = Math.abs(moment(to).diff(from, 'days'));
        if (daysDiff > 62) {
          return 'month';
        } else if (daysDiff <= 1) {
          return 'hour';
        } else {
          return 'day';
        }
    }
    return '';
  }

  get pointInterval(){
    switch (this.aggregatedValue) {
      case 'hour':
        return 3600000;
      case 'day':
      case 'month':
        return ;
    }
    return ;
  }

  get pointIntervalUnit(){
    switch (this.aggregatedValue) {
      case 'hour':
        return ;
      case 'day':
        return 'day';
      case 'month':
        return 'month';
    }
  }

  get aggregatedValuePlusS(){
    switch (this.aggregatedValue) {
      case 'hour':
        return 'hours';
      case 'day':
        return 'days';
      case 'month':
        return 'months';
    }
  }
}

